(function () {
  'use strict';

  // 2026-09-01: subscription upsell (cart panel, interstitial, selling-plan
  // strip/apply machinery) removed. Subscriptions are offered on product pages
  // only; a plan chosen there flows through cart and checkout untouched.

  var PCBC = {
    MINIMUM_CENTS: 15000,
    FREE_SHIPPING_CENTS: 40000,
    // Product types that ship standard rate with NO $150 minimum.
    // Anything not in this list is treated as frozen/perishable (fail-safe:
    // new/unknown product types keep the cold-chain minimum).
    NON_PERISHABLE_TYPES: ['Tallow Skincare', 'Pet', 'Pet Treats'],
  };

  // ===== Utilities =====

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2).replace(/\.00$/, '');
  }

  // Sum of original (pre-plan) prices for frozen/perishable line items only.
  // The $150 minimum exists for cold-chain shipping, so only frozen items count.
  function perishableCentsFromCart(cart) {
    if (!cart || !cart.items) return 0;
    var cents = 0;
    cart.items.forEach(function (item) {
      var type = item.product_type || '';
      if (PCBC.NON_PERISHABLE_TYPES.indexOf(type) === -1) {
        cents += (item.original_price || item.price) * item.quantity;
      }
    });
    return cents;
  }

  function getProgressState(cents) {
    if (cents < PCBC.MINIMUM_CENTS) {
      return {
        pct: Math.round((cents / PCBC.MINIMUM_CENTS) * 100),
        label: 'Add ' + formatMoney(PCBC.MINIMUM_CENTS - cents) + ' more in frozen items. This minimum keeps your order frozen in transit.',
        milestone: 'minimum',
      };
    }
    if (cents < PCBC.FREE_SHIPPING_CENTS) {
      var range = PCBC.FREE_SHIPPING_CENTS - PCBC.MINIMUM_CENTS;
      var progress = cents - PCBC.MINIMUM_CENTS;
      return {
        pct: Math.round((progress / range) * 100),
        label: 'Add ' + formatMoney(PCBC.FREE_SHIPPING_CENTS - cents) + ' more for FREE shipping and save the $49.99+ frozen shipping fee',
        milestone: 'shipping',
      };
    }
    return { pct: 100, label: '✓ Free Shipping Unlocked', milestone: 'complete' };
  }

  // ===== Progress Bar =====
  // Driven by the FROZEN subtotal only. Carts with no frozen items hide the bar
  // entirely (non-perishables ship standard rate with no minimum).

  function updateProgressBars(perishableCents) {
    var state = getProgressState(perishableCents);
    document.querySelectorAll('[data-pcbc-progress-bar]').forEach(function (bar) {
      bar.hidden = perishableCents === 0;
      var fill = bar.querySelector('[data-pcbc-progress-fill]');
      var label = bar.querySelector('[data-pcbc-progress-label]');
      if (fill) fill.style.width = state.pct + '%';
      if (label) label.textContent = state.label;
      bar.dataset.pcbcMilestone = state.milestone;
    });
  }

  // ===== Cart Gate =====
  // The $150 minimum only applies when the cart contains frozen items, and only
  // the frozen subtotal counts toward it. Non-perishable-only carts always
  // check out.

  function updateCheckoutGate(perishableCents) {
    var blocked = perishableCents > 0 && perishableCents < PCBC.MINIMUM_CENTS;
    var btn = document.querySelector('[data-pcbc-checkout-btn]');
    var banner = document.querySelector('[data-pcbc-minimum-banner]');
    if (btn) btn.hidden = blocked;
    if (banner) banner.hidden = !blocked;
  }

  // ===== Cart Drawer Refresh =====
  // Uses the theme's own section-rendering API + eventBus to re-render just the
  // cart drawer dynamic zones without a full page reload.

  function refreshCartDrawer() {
    return fetch(window.Shopify.routes.root + '?sections=cart-drawer')
      .then(function (r) { return r.json(); })
      .then(function (sections) {
        if (sections['cart-drawer'] && window.eventBus) {
          window.eventBus.emit('update:cart:drawer', { sections: sections });
        }
        return fetch('/cart.js').then(function (r) { return r.json(); });
      })
      .then(function (cart) {
        onCartUpdate(cart);
        return cart;
      });
  }

  // ===== Checkout Click =====
  // Goes straight to /checkout. Belt-and-suspenders minimum safety net: only
  // the FROZEN subtotal counts, and only when frozen items are present.

  var _perishableCents = 0; // kept current by onCartUpdate

  function handleCheckoutClick(e) {
    if (window.Shopify && window.Shopify.designMode) return;
    e.preventDefault();
    if (_perishableCents > 0 && _perishableCents < PCBC.MINIMUM_CENTS) {
      window.location.href = '/cart';
      return;
    }
    window.location.href = '/checkout';
  }

  function initCartDelegation() {
    // Capture-phase: catches [data-pcbc-checkout-btn] clicks inside cart-drawer
    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-pcbc-checkout-btn]')) {
        handleCheckoutClick(e);
      }
    }, true);
  }

  // ===== Cart Update Event =====

  function onCartUpdate(cart) {
    if (!cart || typeof cart.total_price === 'undefined') return;
    _perishableCents = perishableCentsFromCart(cart);
    updateProgressBars(_perishableCents);
    updateCheckoutGate(_perishableCents);
  }

  // ===== Preview Bar Pass-through =====

  function applyPreviewBarPassthrough() {
    var pbar = document.getElementById('PBarNextFrameWrapper');
    if (!pbar || pbar.dataset.pcbcFixed) return;
    pbar.style.setProperty('pointer-events', 'none', 'important');
    var iframe = document.getElementById('PBarNextFrame');
    if (iframe) iframe.style.setProperty('pointer-events', 'auto', 'important');
    pbar.dataset.pcbcFixed = '1';
  }

  function watchForPreviewBar() {
    applyPreviewBarPassthrough();
    var observer = new MutationObserver(function () {
      if (document.getElementById('PBarNextFrameWrapper')) {
        applyPreviewBarPassthrough();
        observer.disconnect();
      }
    });
    observer.observe(document.body, { childList: true, subtree: false });
  }

  // ===== Init =====

  function init() {
    var bar = document.querySelector('[data-pcbc-progress-bar]');
    if (bar && bar.dataset.pcbcCartCents) {
      // Frozen subtotal seed rendered by Liquid; fall back to the full total
      // (conservative) until the /cart.js fetch below corrects it.
      var perishableSeed = parseInt(bar.dataset.pcbcPerishableCents || bar.dataset.pcbcCartCents, 10);
      _perishableCents = perishableSeed;
      updateProgressBars(perishableSeed);
      updateCheckoutGate(perishableSeed);
    }

    // Always fetch the live cart so _perishableCents is accurate even on pages
    // where no progress-bar data attribute is present (product pages, etc.).
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) { onCartUpdate(cart); })
      .catch(function () {});

    initCartDelegation();
    watchForPreviewBar();

    if (window.eventBus) {
      // update:cart:drawer fires from TWO sources with different payloads:
      //  • component-cart-quantity.js  → /cart/change.js response → full cart object
      //  • component-product-form.js   → /cart/add.js response → just added items + sections
      window.eventBus.on('update:cart:drawer', function (payload) {
        if (payload && typeof payload.total_price !== 'undefined') {
          onCartUpdate(payload);
        } else {
          fetch('/cart.js')
            .then(function (r) { return r.json(); })
            .then(function (cart) { onCartUpdate(cart); })
            .catch(function () {});
        }
      });

      window.eventBus.on('render:cart:drawer', function () {
        fetch('/cart.js')
          .then(function (r) { return r.json(); })
          .then(function (cart) { onCartUpdate(cart); })
          .catch(function () {});
      });

      window.eventBus.on('cart:added', function () {
        fetch('/cart.js')
          .then(function (r) { return r.json(); })
          .then(function (cart) { onCartUpdate(cart); })
          .catch(function () {});
      });
    }
  }

  // ===== Global API =====
  window.pcbc = {
    handleCheckoutClick: handleCheckoutClick,
    refreshCartDrawer: refreshCartDrawer,
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // bfcache restore: re-fetch the live cart so the gate and progress bar are in
  // sync after Back from checkout.
  window.addEventListener('pageshow', function (event) {
    if (event.persisted) {
      fetch('/cart.js')
        .then(function (r) { return r.json(); })
        .then(function (cart) { onCartUpdate(cart); })
        .catch(function () {});
    }
  });
})();
